import { twMerge } from 'tailwind-merge';

import { Checkbox } from '../Checkbox';

interface Props {
  className?: string;
}

export function LegalCheckbox(props: Props) {
  const checkboxId = 'publisher-terms-consent';

  return (
    <div
      className={twMerge(
        'cursor-pointer',
        'gap-2',
        'grid-cols-[max-content_1fr]',
        'grid',
        'items-start',
        props.className,
      )}
    >
      <label htmlFor={checkboxId} className="flex items-start cursor-pointer">
        <Checkbox id={checkboxId} name="publisherTermsConsent" required />
      </label>
      <label htmlFor={checkboxId} className="text-xs text-white">
        By checking this box and clicking "Continue" below, I agree to, and
        represent that I have read, (i) the{' '}
        <a
          className="underline"
          href="https://solanamobile.com/developer-agreement-web"
          target="_blank"
          rel="noopener noreferrer"
        >
          Solana dApp Store Developer Agreement
        </a>
        , including the arbitration clause{' '}
        <a
          className="underline"
          href="https://solanamobile.com/developer-agreement-web#disputes"
          target="_blank"
          rel="noopener noreferrer"
        >
          linked here
        </a>
        , meaning that, where enforceable, any dispute related to the dApp Store
        will be resolved through BINDING ARBITRATION on an individual, non-class
        basis, (ii) the{' '}
        <a
          className="underline"
          href="https://solanamobile.com/publisher-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Solana Mobile Publisher Policy
        </a>
        , and (iii) the{' '}
        <a
          className="underline"
          href="https://legal.solanamobile.com/en/privacy-policy-web"
          target="_blank"
          rel="noopener noreferrer"
        >
          Solana Mobile Device and dApp Store Privacy Policy
        </a>{' '}
        and{' '}
        <a
          className="underline"
          href="https://solanamobile.com/cookie-policy-web"
          target="_blank"
          rel="noopener noreferrer"
        >
          Cookie Policy
        </a>
        .
      </label>
    </div>
  );
}
